<template>
  <div class="a-logo p-cta">
    <router-link class="a-logo-link" to="/" exact>
      <div class="a-logo-mark">
        <img src="/svg/logo.svg" alt="VR Capital" class="a-logo-svg">
      </div>
    </router-link>
  </div>
</template>

<script>
// import Sniffer from 'sniffer';
// import Logo from './logo';

export default {
  mounted() {
    // if (!Sniffer.isDevice) {
    //   const logo = new Logo();
    //   logo.init();
    // }
  },
};
</script>
